import { useMemo } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { AnswerTrendPoint } from "../../../../services/analytics";

interface Props {
  data?: AnswerTrendPoint[];
}

export default function AnswerCountTrendChart({ data = [] }: Props) {
  const chartData = useMemo(() => {
    return data.map((item) => ({
      ...item,
      label: item.date.slice(5).replace("-", "/"),
    }));
  }, [data]);

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 flex flex-col w-full min-w-0">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-1.5">
          <span className="text-sm font-medium text-gray-700">Answer Count Trend</span>
        </div>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5">
            <div className="w-5 h-0.5" style={{ backgroundColor: "#830051" }} />
            <span className="text-xs text-black">Answer</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-5 border-t-2 border-dashed" style={{ borderColor: "#3CB05C" }} />
            <span className="text-xs text-black">User</span>
          </div>
        </div>
      </div>

      <div className="w-full flex-1 min-h-0">
        <ResponsiveContainer width="100%" height={200}>
          <LineChart data={chartData} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis
              dataKey="label"
              tick={{ fontSize: 11, fill: "#9ca3af" }}
              axisLine={false}
              tickLine={false}
              // interval={0}
              minTickGap={0}
            />
            <YAxis
              tick={{ fontSize: 11, fill: "#9ca3af" }}
              axisLine={false}
              tickLine={false}
              allowDecimals={false}
            />
            <Tooltip
              formatter={(value: number, name: string) => {
                const label = name === "answerCount" ? "Answer" : "User";
                return [`${value.toLocaleString()}`, label];
              }}
              contentStyle={{
                fontSize: 12,
                borderRadius: 6,
                border: "1px solid #e5e7eb",
              }}
            />
            <Line
              type="monotone"
              dataKey="answerCount"
              name="answerCount"
              stroke="#830051"
              strokeWidth={2.5}
              dot={{ r: 3, fill: "#830051" }}
              activeDot={{ r: 4 }}
            />
            <Line
              type="monotone"
              dataKey="userCount"
              name="userCount"
              stroke="#3CB05C"
              strokeWidth={2}
              strokeDasharray="5 4"
              dot={{ r: 3, fill: "#3CB05C" }}
              activeDot={{ r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
